export const LOCAL_STORAGE_KEY = (projectId: string) =>
  `sanityManage:state:getStartedPage:${projectId}`
